import { SnapshotLabelHtmlClassNames } from "@/animation/video-generator";
import { ToolLoadingStateProvider } from "@/grid/ToolLoadingStateContext";
import { useExportStatus } from "@/hooks/useExportStatus";
import { Map as MBMap } from "@/map";
import { MapRecordingLegends } from "@/overlay/components/Legends/MapRecordingLegends";
import { MapRecordingLabelCanvas } from "@/overlay/components/QuickAccessLabel/MapRecordingLabelCanvas";
import { classNames } from "@/utility/jsx";
import type { CartographicMapOutput, GridCellLayout } from "@mm/metx-workbench.meteomatics.com";
import { Suspense, lazy, memo, useRef } from "react";

export type GridMapProps = {
  map: CartographicMapOutput;
  cellLayout: GridCellLayout;
};

const MapOverlay = memo(
  lazy(() =>
    import("@/overlay/overlays/default/MapOverlay")
      .then(({ DefaultMapOverlay }) => ({ default: DefaultMapOverlay }))
      .catch(() => {
        console.error("error");
        return { default: () => <div>Loading Map Overlay failed</div> };
      }),
  ),
);

export function GridMap({ map, cellLayout }: GridMapProps) {
  const mapRef = useRef<HTMLDivElement>(null);
  const { isVideoExportActive } = useExportStatus();

  return (
    <ToolLoadingStateProvider>
      <div className="overlay">
        <div className="overlay__layer">
          {/* TODO Maybe pass whole map? */}
          <MBMap id={{ profile: map.id_profile, tab: map.id_tab, map: map.id }} resizeCompensationRef={mapRef} />
        </div>

        {isVideoExportActive ? (
          <div className="overlay__layer">
            <MapRecordingLabelCanvas map={map} />
            <MapRecordingLegends map={map} cellLayout={cellLayout} />
          </div>
        ) : (
          <div ref={mapRef} className={classNames("overlay__layer", "gui-overlay", SnapshotLabelHtmlClassNames.Map)}>
            <Suspense fallback={<mm-loader size="large" />}>
              <MapOverlay map={map} cellLayout={cellLayout} mapRef={mapRef} />
            </Suspense>
          </div>
        )}
      </div>
    </ToolLoadingStateProvider>
  );
}
